import React from 'react';
import { Tooltip } from 'antd';
import editIcon from '../../assets/icons/edit.svg';
import editDisableIcon from '../../assets/icons/edit_disable.svg';
import plusDisableIcon from '../../assets/icons/plus-icon-disabled.svg';
import plusIcon from '../../assets/icons/plus-icon.svg';
import showLess from '../../assets/icons/show-less.svg';
import showMore from '../../assets/icons/show-more.svg';
import arrowRight from '../../assets/icons/short-arrow-r-green.svg';
import binIcon from '../../assets/icons/bin.svg';

import { LinkNavigatorWrapper } from '../CTA/styles';
import {
  CommonCapsuleStyle,
  CapsuleIcon,
  VerticalAlign,
  FunctionalBtnStyles,
  FunctionalBtnWrapper,
} from './styles';

const fetchIcon = (disabled, type) => {
	switch (type) {
		case 'edit':
			return disabled ? editDisableIcon : editIcon;
		case 'add':
			return disabled ? plusDisableIcon : plusIcon;
		case 'arrowUp':
			return showLess;
		case 'arrowDown':
			return showMore;
		case 'arrowRight':
      return arrowRight;
    case 'binIcon':
      return binIcon;
		default:
			break;
	}
};
/**
 * Common Component: Capsule Button
 * Props :
 * text - Button Text
 * onClick - onClick Function
 * height - Height of the button, if null then default
 * padding - padding provided, if null then default
 * mobHeight - height for media query
 * disabled - boolean input for true and false
 * icon - pass the icon ( svg )
 * width - width of the button if null default 
 * lineHeight - content line-height  if null default
 * fontSize - Font size for the text, if null will accept default mentioned in styles.js
 * enableleft - Margin left, if null default
 * top - Margin top, if null then default
 * mobWidth - width - mobile view works only if mobHeight is true 
 */
export const CapsuleButton = ({ 
	text = '', 
	onClick = null, 
  disabled = false,
  height = false, 
  mobHeight = false,
  padding = null,
	iconType = null, 
	id = '', 
  whiteBackground = false,
  mobWidth = '',
  width = "",
  lineHeight="",
  fontSize = "14px",
  enableLeft = '',
  top = '',
  styles='',
  alt=''
}) => {
	return (
		<CommonCapsuleStyle
			whiteBackground={whiteBackground}
			disabled={disabled}
      id={id}
      height={height}
      mobHeight={mobHeight}
      padding={padding}
      onClick={onClick ? onClick : () => false}
      mobWidth={mobWidth}
      width={width}
      lineHeight={lineHeight}
      fontSize={fontSize}
      enableLeft={enableLeft}
      top={top}
      className={styles}
      mobWidth = {mobWidth}
		>
			<VerticalAlign>{text}</VerticalAlign>
			{iconType &&
			 <CapsuleIcon src={fetchIcon(disabled, iconType)} alt={alt} />
			 }
		</CommonCapsuleStyle>
	);
};

const ArrowBtn = (props) => {
  return (
    <span>
      {!props.leftArrow && props.cta}
      <span className='new_arrow'>
        <span className='arrow_line'>
          <span></span>
        </span>
      </span>
      {props.leftArrow && props.cta}
    </span>
  );
};
/**
 * Common Component: Tooltip Wrapper
 * Props :
 * element - wrapped element
 * placement - tooltip placement
 * text - Tooltip wrapper text
 */
export const TooltipWrapper = ({ element, placement, text }) => {
  return (
    <Tooltip placement={placement ? placement : 'right'} title={text}>
      {element}
    </Tooltip>
  );
};
/**
 * Common Component: General Button
 * Props :
 * disabled - boolean input for true and false
 * text - Button Text
 * type - pass the icon ( svg )
 * onClick - onClick Function
 * width - width accordingly
 * mobWidth - width for media query
 * styling - custom class name configuration
 * htmlType- To add HTML <button> type Attribute like Submit,reset,text etc
 * maxWidth - width for mobile view
 * mobMargin- To add margin for mobile view
 * fonSize - font size
 * [type='functional'] - props.inverted - true(Functional:Primary) / false(Functional:Secondary)
 */
export const GeneralButton = (props) => {
  const {
    disabled = false,
    text = '',
    type = '',
    onClick,
    width = null,
    id = '',
    styling = '',
    mobWidth = null,
    htmlType="",
    mobMargin= null,
    maxWidth = "767px",
    fontSize = ''
  } = props;
  switch (type) {
    case 'primary':
      return (
        <FunctionalBtnWrapper
          data-test='primaryBtnClick'
          leftArrow={false}
          width={width}
          disabled={disabled}
          mobWidth={mobWidth}
          onClick={onClick}
          id={id}
          className={styling}
          maxWidth={maxWidth}
        >
          {text} <ArrowBtn cta={false} disabled={disabled} />
        </FunctionalBtnWrapper>
      );
    case 'secondary':
      return (
        <FunctionalBtnWrapper
          leftArrow={false}
          width={width}
          disabled={disabled}
          mobWidth={mobWidth}
          onClick={onClick}
          id={id}
          className={styling}
          inverted={true}
          maxWidth={maxWidth}
        >
          {text} <ArrowBtn cta={false} disabled={disabled} />
        </FunctionalBtnWrapper>
      );
    case 'functional':
      return (
        <FunctionalBtnStyles
          type={type}
          width={width}
          disabled={disabled}
          mobWidth={mobWidth}
          onClick={onClick}
          id={id}
          className={styling}
          inverted={props.inverted}
          htmlType={htmlType}
          mobMargin={mobMargin}
          maxWidth={maxWidth}
          fontSize={fontSize}
        >
          {text}
        </FunctionalBtnStyles>
      );
    case 'tertiary':
      return (
        <LinkNavigatorWrapper
          color='#006778'
          disabled={disabled}
          mobWidth={mobWidth}
          onClick={onClick}
          className={styling}
          id={id}
          tabNavigation={props.tabNavigation}
        >
          <ArrowBtn cta={text} />
        </LinkNavigatorWrapper>
      );
    default:
      return (
        <FunctionalBtnStyles
          disabled={disabled}
          width={width}
          mobWidth={mobWidth}
          onClick={onClick}
          id={id}
          className={styling}
          maxWidth={maxWidth}
        >
          {text}
        </FunctionalBtnStyles>
      );
  }
};
